export const TrailerMake = [
  'Aldura',
  'Alutrec',
  'AMC',
  'American',
  'Arnes',
  'Aspen',
  'Astro',
  'Atlantic',
  'Atoka',
  'Aztec',
  'Benson',
  'Birmingham',
  'Brown',
  'BTTL',
  'BWS',
  'Champion',
  'Chaparrai',
  'Chariot',
  'Commorore',
  'Cozad',
  'Craftman',
  'Custom',
  'Dakota',
  'Davis',
  'Deloupe',
  'Diamond',
  'Doepker',
  'Domes',
  'Doonan',
  'Dorsey',
  'Dynaweld',
  'Eager Beaver',
  'Eagle',
  'East Manuf.',
  'Entyre',
  'Etnyre',
  'Excel',
  'Extreme',
  'Falls',
  'Fontaine',
  'Fruhauf',
  'Fruehauf',
  'GOC',
  'Great Dane',
  'Highland',
  'Homemade',
  'Hyster',
  'Hyundai',
  'JC',
  'JCTR',
  'Jet Company',
  'KALY',
  'Kalyn',
  'Kaufman',
  'Kentucky',
  'King TRL',
  'Landoll',
  'Liddell',
  'Load Craft',
  'Load King',
  'Lode King',
  'Lufkin',
  'Mac TRL',
  'Magnum',
  'Manac',
  'Markline',
  'McCloskey',
  'Minideck',
  'Nelson',
  'Nu Energy',
  'Perfect',
  'Pesco',
  'Pine Hill',
  'PITTS',
  'PRATT',
  'Precision & Lakeside',
  'Reitnouer',
  'Roger',
  'Rogers',
  'Rotec',
  'Scheltema',
  'Siebert',
  'Stanton Dyne',
  'Stoughten',
  'Talbert',
  'Temisko',
  'Thruway',
  'Trail King',
  'Trail Mobile',
  'Trail-Eze',
  'Transcraft',
  'Transport',
  'Transtech',
  'Unknown',
  'Utility',
  'Various',
  'Wabash',
  'Waltron',
  'Wilson',
  'WKM',
  'XL',
  'XL Specialized',
  'Xtreme',
] as const;
